import type { createApp as djangoCreateApp, Plugin } from 'vue'

import gettext from 'gettext-congress'
import widgetPlugin from './widgetPlugin.mts'

import BootstrapCardOrModal from '#src/vue/BootstrapCardOrModal.vue'
import ModalContent from '#src/vue/BootstrapModalContent.vue'
import CloseModalButton from '#src/vue/CloseModalButton.vue'
import PopupRouterLink from '#src/vue/PopupRouterLink.vue'
import RemoteContent from '#src/vue/RemoteContent.vue'


export type PluginOptions = {
  // The createApp function to use when mounting nested (remote) apps, such as the widgetPlugin.
  createApp: typeof djangoCreateApp,
}

/**
 * Don't want to use a plugin? Feel that you should be able to import the data at the point of use?
 * Use this function
 */
export function provideRemoteContentConfig (app: ReturnType<typeof djangoCreateApp>, options: PluginOptions) {
    app.provide('LayoutCongress', options)
}

export const remoteContentPlugin = {
  install (app, options) {
    const { createApp: baseCreateApp, ..._options } = options
    if (!baseCreateApp || typeof baseCreateApp !== 'function') {
      console.error("remoteContentPlugin missing required parameter: createApp")
    }

    const createApp: typeof baseCreateApp = (rootComponent) => {
      const app = baseCreateApp(rootComponent)

      // register components needed when parsing remote content
      app
        .use(gettext as any)
        .use(widgetPlugin)
        .component('RemoteContent', RemoteContent)
        .component('BootstrapModalContent', ModalContent)
        .component('CloseModalButton', CloseModalButton)
        .component('BootstrapCardOrModal', BootstrapCardOrModal)
        .component('PopupRouterLink', PopupRouterLink)

      return app
    }

    const providedOptions = {
      createApp,
      ..._options,
    }

    // provide an init function for NestedEntrypoint
    provideRemoteContentConfig(app, providedOptions)

  }
} as Plugin<PluginOptions>
